import axios from 'axios';

export const apiUrl = process.env.REACT_APP_API_URL;

export function buildApiUrl(path: string = ''): string {
  return apiUrl + path;
}

const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

export default apiClient;
